module.exports = __webpack_public_path__ + "static/media/icon-cup.61f9f771.png";